var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptionsIcon = function SvgOptionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M11 7.344a1.344 1.344 0 1 0 0-2.688 1.344 1.344 0 0 0 0 2.688M12.344 11a1.344 1.344 0 1 1-2.688 0 1.344 1.344 0 0 1 2.688 0M12.344 16a1.344 1.344 0 1 1-2.688 0 1.344 1.344 0 0 1 2.688 0"
  })));
};
export default SvgOptionsIcon;